import React from "react";
import { Translation } from "react-i18next";

export const AssignmentPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      title: (
        <Translation>{(t) => t("navigation.main.assignment_list")}</Translation>
      ),
      path: "/assignments",
      exact: true,
      component: React.lazy(() => import("./assignments/AssignmentsPage")),
    },
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.submit_new_assignment")}
        </Translation>
      ),
      path: "/assignments/add-assignment",
      exact: true,
      component: React.lazy(() => import("./add-assignment/AddAssignmentPage")),
    },
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.question_management")}
        </Translation>
      ),
      path: "/assignments/:id",
      exact: true,
      component: React.lazy(() =>
        import("./assignmentQuestion/AssignmentQuestionPage")
      ),
    },
    {
      title: (
        <Translation>{(t) => t("navigation.main.edit_assignment")}</Translation>
      ),
      path: "/assignments/add-assignment/:id",
      exact: true,
      component: React.lazy(() => import("./add-assignment/AddAssignmentPage")),
    },
    {
      title: (
        <Translation>
          {(t) => t("navigation.main.assignment_student_report")}
        </Translation>
      ),
      path: "/assignments/assignment-student-report/:id",
      exact: true,
      component: React.lazy(() =>
        import("./assignment-student-report/AssignmentStudentReportPage")
      ),
    },
    {
      title: <Translation>{(t) => t("navigation.main.workbook")}</Translation>,
      path: "/assignments/work-book/:id/:studentID",
      exact: true,
      component: React.lazy(() => import("./work-book/WorkBookPage")),
    },
  ],
};
